export const getBaseUrl = () => {
  const {protocol, hostname, port} = window.location
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`
}
